import React, { useState, useEffect } from 'react';
import { api } from '../api/client.ts';
import { useGame } from '../state/gameStore.tsx';
import type { FleetMovementItem } from '@galaxy/shared';

export const FleetMovementBar: React.FC = () => {
  const { refreshState } = useGame();
  const [movements, setMovements] = useState<FleetMovementItem[]>([]);
  const [recallingId, setRecallingId] = useState<string | null>(null);

  const fetchMovements = async () => {
    try {
      const res = await api.getFleetMovements();
      // Keep only active movements
      const active = res.movements.filter(m => m.status === 'marching' || m.status === 'returning');
      setMovements(active);
    } catch {}
  };

  useEffect(() => {
    fetchMovements();
    const interval = setInterval(fetchMovements, 2000);
    return () => clearInterval(interval);
  }, []);

  const handleRecall = async (movementId: string) => {
    try {
      setRecallingId(movementId);
      await api.recallFleet(movementId);
      await refreshState();
      await fetchMovements();
    } catch (err: any) {
      alert(err.message || 'Lỗi khi ra lệnh quay đầu!');
    } finally {
      setRecallingId(null);
    }
  };

  if (movements.length === 0) return null;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      padding: '8px 12px',
      background: 'rgba(5, 12, 25, 0.95)',
      borderBottom: '1px solid rgba(0, 240, 255, 0.3)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.5)',
    }}>
      <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#00f0ff', display: 'flex', justifyContent: 'space-between' }}>
        <span>📡 HÀM ĐỘI ĐANG HÀNH QUÂN ({movements.length})</span>
      </div>

      {movements.map((m) => {
        const totalShips = m.fleet_composition.reduce((acc, s) => acc + s.count, 0);
        const isMarching = m.status === 'marching';
        const isReturning = m.status === 'returning';

        return (
          <div key={m.id} style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: 'rgba(0, 20, 40, 0.5)',
            border: `1px solid ${isMarching ? '#00f0ff' : '#ffd700'}`,
            borderRadius: 6,
            padding: '6px 10px',
            fontSize: '11px',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <span>{isMarching ? '🚀' : '↩️'}</span>
              <div>
                <span style={{ fontWeight: 'bold', color: isMarching ? '#00f0ff' : '#ffd700' }}>
                  {isMarching ? 'Đang bay đến' : 'Đang quay về'} [{m.target_x}, {m.target_y}]
                </span>
                <span style={{ color: '#88a0c0', marginLeft: 6 }}>
                  ({totalShips} tàu • {m.mission_type})
                </span>
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ color: '#00e5ff', fontWeight: 'bold' }}>
                ⏳ {m.remaining_sec ?? 0}s
              </span>

              {isMarching && (
                <button
                  onClick={() => handleRecall(m.id)}
                  disabled={recallingId === m.id}
                  style={{
                    background: 'rgba(255, 215, 0, 0.15)',
                    border: '1px solid #ffd700',
                    color: '#ffd700',
                    fontSize: '10px',
                    fontWeight: 'bold',
                    borderRadius: 4,
                    padding: '3px 8px',
                    cursor: 'pointer',
                  }}
                >
                  {recallingId === m.id ? '...' : 'Quay Đầu'}
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
